module.exports = __webpack_public_path__ + "img/default.7a21cbe9.svg";